import { action, makeAutoObservable } from "mobx";
import { v4 as uuidv4 } from "uuid";
import { User } from "../../models/user/user";
import app from "../../app";
import { getTypedObjectFromFirebase } from "../firebase/fireStoreHelpers/fireStoreHelpers";
export interface IUserStore {
  address: string;
  userName: string;
  email: string;
  avatar: string;
  twitter: string;
  url: string;
  bio: string;
  subscribed: boolean;
}

export class UserStore implements IUserStore {
  id = uuidv4();
  isConnected = false;
  // isAuthenticated = false;
  address = "";
  userName = "";
  email = "";
  avatar = "";
  twitter = "";
  url = "";
  bio = "";
  subscribed = false;
  isAuthenticated = false;

  constructor() {
    makeAutoObservable(this);
  }

  @action setUser = async (userData: User): Promise<void> => {
    //  console.log('TTT')
    this.address = userData.address;
    this.userName = userData.userName;
    this.email = userData.email;
    this.avatar = userData.avatar;
    this.twitter = userData.twitter;
    this.url = userData.url;
    this.bio = userData.bio;
    this.subscribed = await this._getIsSubscribed();
  };

  @action loadUserByAddress = async (address: string): Promise<void> => {
    try {
      const result: User = await getTypedObjectFromFirebase<User>('users', address);
      if (result) {
        this.setUser(result);
      } else {
        this.address = address;
        this.subscribed = await this._getIsSubscribed();
      }

    } catch (err) {
      console.log(err);
    }

  };


  @action setUserAvatar = (newAvatar: string): void => {
    this.avatar = newAvatar;
  };

  @action setUserName = (userName: string): void => {
    this.userName = userName;
  };
  @action setUserEmail = (email: string): void => {
    this.email = email;
  };
  @action setUserUrl = (url: string): void => {
    this.url = url;
  };

  @action setIsAuthenticated = (isAuth: boolean): void => {
    this.isAuthenticated = isAuth;
  };

  @action setUserBio = (bio: string): void => {
    this.bio = bio;
  };
  @action setUserTwitter = (twitter: string): void => {
    this.twitter = twitter;
  };
  @action saveUser = async (): Promise<void> => {
    const userToSave = {
      address: this.address,
      userName: this.userName,
      email: this.email,
      avatar: this.avatar,
      twitter: this.twitter,
      url: this.url,
      bio: this.bio,
      subscribed: this.subscribed,
    };
    await app.fb.saveToDB("users", this.address, userToSave);
  };

  async _getIsSubscribed(): Promise<boolean> {
    //  console.log('_getIsSubscribed')
    //  const abi = ["function getLatestPrice() public view returns (int)"];
    try {
      //  const tokenContract = new ethers.Contract(app.vars.rinkebyConAdd, abi, app.web3.ethersProvider);
      //  const latestPrice: BigNumber = await tokenContract.getLatestPrice();

      return true;
    } catch (error) {
      console.log('Error ', error);
      return false;
    }
  }
}
